document.addEventListener('DOMContentLoaded', function() {
  // Guard — only run on the quote generator page
  if (!document.getElementById('cbco-windowList')) return;

  // Pricing comes live from each product's [RETOOL] Pricing metafield
  // (custom.pricing), served same-origin by templates/product.pricing.liquid.
  function pricingUrl(handle) { return '/products/' + encodeURIComponent(handle) + '?view=pricing'; }
  var pricingState = {};
  var RANGES = null;
  var state = { windows: [] };
  var nextId = 1;

  var CAT_ORDER  = ['Sheers','Blackout Curtains','Roller Blinds','Blinds','Shutters'];
  var CAT_LABELS = { 'Blackout Curtains': 'Blockout Curtains' };
  var SEWN_HEM_EXCLUDED = ['allusion','cloud',
    'allusion_sheer_curtain','cloud_sheer_curtain']; // handles, plus legacy fallback keys
  var ROLLER_MOTOR_OPTIONS = [
    { label: 'Eve Motionblinds motor',      cost: 299 },
    { label: 'Motionblinds Bluetooth motor', cost: 199 }
  ];
  var CURTAIN_MOTOR_COST = 599;

  /* ── PRICE LOOKUP ── */
  function priceFor(w) {
    if (!RANGES) return 0;
    var r = RANGES[w.rangeKey];
    if (!r || !r.pricing) return 0;
    var W = parseFloat(w.width), H = parseFloat(w.height);
    if (!W || !H) return 0;
    if (W < r.minW || W > r.maxW || H < r.minH || H > r.maxH) return 0;
    var pricing = r.pricing;
    var wKeys = Object.keys(pricing).sort(function(a,b){return parseFloat(a)-parseFloat(b);});
    var wKey = null;
    for (var i=0; i<wKeys.length; i++) { if (parseFloat(wKeys[i]) >= W) { wKey = wKeys[i]; break; } }
    if (wKey === null) return 0;
    var drops = pricing[wKey];
    var dKeys = Object.keys(drops).sort(function(a,b){return parseFloat(a)-parseFloat(b);});
    var dKey = null;
    for (var j=0; j<dKeys.length; j++) { if (parseFloat(dKeys[j]) >= H) { dKey = dKeys[j]; break; } }
    if (dKey === null) return 0;
    var base = parseFloat(drops[dKey]) || 0;
    if (w.sewn && r.category === 'Sheers' && SEWN_HEM_EXCLUDED.indexOf(w.rangeKey) === -1) {
      base = base * 1.2;
    }
    if (w.motorised === 'Yes') {
      if (r.motorType === 'curtain') {
        base += CURTAIN_MOTOR_COST;
      } else if (r.motorType === 'roller' && w.motorOption) {
        var opt = ROLLER_MOTOR_OPTIONS.filter(function(o){ return o.label === w.motorOption; })[0];
        if (opt) base += opt.cost;
      }
    }
    return base;
  }

  function fmt(n) {
    return '$' + Number(n).toLocaleString('en-AU',{minimumFractionDigits:2,maximumFractionDigits:2});
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});
  }

  /* ── RANGE DROPDOWN ── */
  function buildGroupedOptions(selectedKey) {
    if (!RANGES) return '';
    var groups = {};
    CAT_ORDER.forEach(function(c){ groups[c] = []; });
    Object.keys(RANGES).sort(function(a,b){
      var ra=RANGES[a], rb=RANGES[b];
      var ci = CAT_ORDER.indexOf(ra.category) - CAT_ORDER.indexOf(rb.category);
      if (ci !== 0) return ci;
      return ra.label.localeCompare(rb.label);
    }).forEach(function(k){
      var r = RANGES[k];
      if (groups[r.category]) groups[r.category].push([k,r]);
    });
    return CAT_ORDER.map(function(cat){
      var items = groups[cat];
      if (!items || !items.length) return '';
      return '<optgroup label="' + (CAT_LABELS[cat]||cat) + '">' +
        items.map(function(e){
          return '<option value="' + esc(e[0]) + '"' + (selectedKey===e[0]?' selected':'') + '>' + esc(e[1].label) + '</option>';
        }).join('') + '</optgroup>';
    }).join('');
  }

  /* ── VALIDATION ── */
  function invalidW(w) {
    if (!w.width || !RANGES) return false;
    var r = RANGES[w.rangeKey]; if (!r) return false;
    var v = parseFloat(w.width); return v < r.minW || v > r.maxW;
  }
  function invalidH(w) {
    if (!w.height || !RANGES) return false;
    var r = RANGES[w.rangeKey]; if (!r) return false;
    var v = parseFloat(w.height); return v < r.minH || v > r.maxH;
  }

  /* ── RENDER ── */
  function render() { renderWindows(); renderSummary(); }

  function renderWindows() {
    var list = document.getElementById('cbco-windowList');
    list.innerHTML = '';
    state.windows.forEach(function(w, idx) {
      var r = RANGES && RANGES[w.rangeKey];
      var price = priceFor(w);
      var card = document.createElement('div');
      card.className = 'qg-window';
      card.innerHTML =
        '<div class="win-head">' +
          '<div class="win-num">' + String(idx+1).padStart(2,'0') + '</div>' +
          '<input class="win-title-input" data-id="' + w.id + '" data-k="name" value="' + esc(w.name) + '" placeholder="e.g. Living Room North" />' +
          '<div class="win-price' + (price?'':' empty') + '">' + (price?fmt(price):'Enter details') + '</div>' +
          '<button class="win-remove" data-remove="' + w.id + '" title="Remove window">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M10 11v6M14 11v6"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="win-body">' +
          '<div class="field col-12">' +
            '<label>Range</label>' +
            '<select class="qg-select" data-id="' + w.id + '" data-k="rangeKey">' +
              '<option value="">— Select a range —</option>' +
              buildGroupedOptions(w.rangeKey) +
            '</select>' +
          '</div>' +
          (r ?
            '<div class="field col-6">' +
              '<label>Width</label>' +
              '<div class="input-mm"><input class="qg-input' + (invalidW(w)?' invalid':'') + '" type="number" data-id="' + w.id + '" data-k="width" value="' + w.width + '" placeholder="e.g. 1800" inputmode="numeric" /></div>' +
              '<span class="' + (invalidW(w)?'err':'hint') + '">' + (invalidW(w)?'Width must be '+r.minW+'–'+r.maxW+'mm':'Within '+r.minW+'–'+r.maxW+'mm') + '</span>' +
            '</div>' +
            '<div class="field col-6">' +
              '<label>Drop (height)</label>' +
              '<div class="input-mm"><input class="qg-input' + (invalidH(w)?' invalid':'') + '" type="number" data-id="' + w.id + '" data-k="height" value="' + w.height + '" placeholder="e.g. 2400" inputmode="numeric" /></div>' +
              '<span class="' + (invalidH(w)?'err':'hint') + '">' + (invalidH(w)?'Drop must be '+r.minH+'–'+r.maxH+'mm':'Within '+r.minH+'–'+r.maxH+'mm') + '</span>' +
            '</div>' +
            (r.motorType !== 'none' ?
              '<div class="field col-6">' +
                '<label>Motorised tracks</label>' +
                '<div class="seg" data-id="' + w.id + '" data-k="motorised">' +
                  '<button class="' + (w.motorised==='No'?'on':'') + '" data-v="No">No</button>' +
                  '<button class="' + (w.motorised==='Yes'?'on':'') + '" data-v="Yes">Yes</button>' +
                '</div>' +
              '</div>' +
              (r.motorType === 'roller' && w.motorised === 'Yes' ?
                '<div class="field col-6"><label>Motor type</label>' +
                  '<select class="qg-select" data-id="' + w.id + '" data-k="motorOption">' +
                    '<option value="">— Choose motor —</option>' +
                    ROLLER_MOTOR_OPTIONS.map(function(o){
                      return '<option value="' + esc(o.label) + '"' + (w.motorOption===o.label?' selected':'') + '>' + esc(o.label) + ' (+$' + o.cost + ')</option>';
                    }).join('') +
                  '</select>' +
                '</div>'
              : r.motorType === 'curtain' && w.motorised === 'Yes' ?
                '<div class="field col-6" style="justify-content:flex-end"><span class="hint" style="color:var(--green);font-weight:600">+$' + CURTAIN_MOTOR_COST + ' motorised track included</span></div>'
              : '<div class="field col-6"></div>')
            : '') +
            (r.category === 'Sheers' ?
              SEWN_HEM_EXCLUDED.indexOf(w.rangeKey) === -1 ?
                '<div class="field col-12"><label class="qg-check-wrap"><input type="checkbox" data-id="' + w.id + '" data-k="sewn"' + (w.sewn?' checked':'') + ' /><span class="check-text">Sewn hem finish <span style="color:var(--green);font-weight:700">+20%</span></span></label><span class="check-note">All of our ranges come with a weighted hem by default.</span></div>'
              : '<div class="field col-12"><span class="check-note">This range has a sewn hem by default.</span></div>'
            : '')
          :
            '<div class="field col-12"><span class="hint" style="padding:12px 0;display:block;">Choose a range above to enter measurements.</span></div>'
          ) +
        '</div>';
      list.appendChild(card);
    });
    bindEvents();
  }

  function bindEvents() {
    document.querySelectorAll('[data-remove]').forEach(function(b){
      b.addEventListener('click',function(){ removeWindow(parseInt(b.dataset.remove,10)); });
    });
    document.querySelectorAll('input[data-id],select[data-id]').forEach(function(el){
      el.addEventListener('input',onFieldChange);
      el.addEventListener('change',onFieldChange);
    });
    document.querySelectorAll('.seg button').forEach(function(btn){
      btn.addEventListener('click',onSegClick);
    });
  }

  function onSegClick(e) {
    var seg = e.target.closest('.seg');
    if (!seg) return;
    var id = parseInt(seg.dataset.id,10);
    var k = seg.dataset.k;
    var v = e.target.dataset.v;
    var w = state.windows.filter(function(x){return x.id===id;})[0];
    if (!w) return;
    w[k] = v;
    if (k==='motorised' && v==='No') w.motorOption = '';
    render();
  }

  function onFieldChange(e) {
    var id = parseInt(e.target.dataset.id,10);
    var k = e.target.dataset.k;
    var v = e.target.value;
    var w = state.windows.filter(function(x){return x.id===id;})[0];
    if (!w) return;
    if (e.target.type==='checkbox') { w[k]=e.target.checked; render(); return; }
    if (e.target.tagName==='INPUT' && k!=='rangeKey') {
      w[k] = v;
      if (k==='width'||k==='height') {
        renderSummary();
        var card = e.target.closest('.qg-window');
        var priceEl = card.querySelector('.win-price');
        var p = priceFor(w);
        priceEl.textContent = p ? fmt(p) : 'Enter details';
        priceEl.classList.toggle('empty',!p);
        var r = RANGES && RANGES[w.rangeKey];
        if (r) {
          var isW = k==='width', bad = isW?invalidW(w):invalidH(w);
          e.target.classList.toggle('invalid',bad);
          var errEl = e.target.parentElement.parentElement.querySelector('.err,.hint');
          if (errEl) {
            errEl.className = bad?'err':'hint';
            errEl.textContent = bad ? (isW?'Width must be '+r.minW+'–'+r.maxW+'mm':'Drop must be '+r.minH+'–'+r.maxH+'mm') : (isW?'Within '+r.minW+'–'+r.maxW+'mm':'Within '+r.minH+'–'+r.maxH+'mm');
          }
        }
        return;
      }
      if (k==='name') { renderSummary(); return; }
    }
    if (k==='rangeKey' && w.rangeKey!==v) { w.width=''; w.height=''; w.motorised='No'; w.motorOption=''; w.sewn=false; }
    w[k] = v;
    if (k==='rangeKey' && v) ensurePricing(v);
    render();
  }

  function makeBlank() {
    return { id:nextId++, name:'Window '+(state.windows.length+1), rangeKey:'', width:'', height:'', motorised:'No', motorOption:'', sewn:false };
  }
  function addWindow() { state.windows.push(makeBlank()); render(); }
  function removeWindow(id) {
    state.windows = state.windows.filter(function(w){return w.id!==id;});
    render(); toast('Window removed');
  }

  /* ── SUMMARY ── */
  function renderSummary() {
    var sumList = document.getElementById('cbco-sumList');
    var sumTotals = document.getElementById('cbco-sumTotals');
    var dl = document.getElementById('cbco-downloadBtn');
    if (!state.windows.length) {
      sumList.innerHTML = '<div class="sum-empty">Add a window to start your quote.</div>';
      sumTotals.style.display='none'; dl.disabled=true; return;
    }
    var html='', subtotal=0, priced=0;
    state.windows.forEach(function(w,i){
      var r=RANGES&&RANGES[w.rangeKey], p=priceFor(w);
      if(p){subtotal+=p;priced++;}
      var name=w.name||'Window '+(i+1);
      var detail=r?r.label:'No range selected';
      var dims=(w.width&&w.height)?w.width+' × '+w.height+' mm':'—';
      html+='<div class="sum-line"><div class="lbl">'+esc(name)+'<small>'+esc(detail)+' · '+esc(dims)+'</small></div><div class="val'+(p?'':' empty')+'">'+(p?fmt(p):'pending')+'</div></div>';
    });
    sumList.innerHTML=html;
    if(priced>0){
      sumTotals.style.display='block';
      var gst=subtotal/11,ex=subtotal-gst;
      document.getElementById('cbco-subtotal').textContent=fmt(ex);
      document.getElementById('cbco-gst').textContent=fmt(gst);
      document.getElementById('cbco-grand').textContent=fmt(subtotal);
      dl.disabled=false;
    } else { sumTotals.style.display='none'; dl.disabled=true; }
  }

  /* ── PDF ── */
  function downloadPDF() {
    var jsPDF=window.jspdf&&window.jspdf.jsPDF;
    if(!jsPDF){toast('PDF library not ready. Please wait and try again.');return;}
    var doc=new jsPDF({unit:'pt',format:'a4'});
    var PW=doc.internal.pageSize.getWidth(),PH=doc.internal.pageSize.getHeight(),M=48;
    doc.setFillColor(63,117,83); doc.rect(0,0,PW,100,'F');
    doc.setFillColor(233,205,150); doc.rect(0,100,PW,4,'F');
    doc.setFillColor(245,242,240); doc.rect(0,104,PW,PH-104,'F');
    doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255); doc.setFontSize(20);
    doc.text('Curtain & Blind Co',M,50);
    doc.setFont('helvetica','normal'); doc.setFontSize(10.5); doc.setTextColor(209,230,199);
    doc.text('Estimative Quote  ·  curtainandblindco.com.au',M,72);
    var today=new Date().toLocaleDateString('en-AU',{day:'numeric',month:'long',year:'numeric'});
    var qref='CBC-'+Date.now().toString().slice(-6);
    doc.setTextColor(255,255,255); doc.setFontSize(9.5);
    doc.text('Date: '+today,PW-M,50,{align:'right'});
    doc.text('Ref: '+qref,PW-M,66,{align:'right'});
    var y=148;
    doc.setFont('helvetica','bold'); doc.setFontSize(16); doc.setTextColor(29,29,27);
    doc.text('Your itemised quote',M,y); y+=14;
    doc.setDrawColor(221,215,207); doc.setLineWidth(0.6); doc.line(M,y,PW-M,y); y+=20;
    doc.setFont('helvetica','normal'); doc.setFontSize(8.5); doc.setTextColor(138,138,133);
    doc.text('WINDOW',M,y); doc.text('PRODUCT',M+140,y); doc.text('SIZE (W \xd7 H)',M+315,y); doc.text('PRICE',PW-M,y,{align:'right'}); y+=8;
    doc.line(M,y,PW-M,y); y+=16;
    var subtotal=0;
    doc.setTextColor(29,29,27); doc.setFontSize(10.5);
    state.windows.forEach(function(w,i){
      if(y>PH-160){doc.addPage();doc.setFillColor(245,242,240);doc.rect(0,0,PW,PH,'F');y=M+10;}
      var r=RANGES&&RANGES[w.rangeKey],p=priceFor(w);
      var name=w.name||'Window '+(i+1);
      var product=r?r.label:'(no range selected)';
      var dims=(w.width&&w.height)?w.width+' \xd7 '+w.height+' mm':'—';
      if(p)subtotal+=p;
      doc.setFont('helvetica','bold'); doc.setTextColor(29,29,27);
      doc.text(String(i+1).padStart(2,'0')+'  '+trunc(name,20),M,y);
      doc.setFont('helvetica','normal');
      doc.text(trunc(product,32),M+140,y); doc.text(dims,M+315,y);
      doc.setTextColor(p?63:138,p?117:138,p?83:133);
      doc.text(p?fmt(p):'pending',PW-M,y,{align:'right'}); doc.setTextColor(29,29,27);
      var meta=[];
      if(w.motorised==='Yes'){
        if(r&&r.motorType==='curtain') meta.push('Motorised track (+$'+CURTAIN_MOTOR_COST+')');
        else if(r&&r.motorType==='roller'&&w.motorOption) meta.push(w.motorOption);
      }
      if(w.sewn&&r&&r.category==='Sheers'&&SEWN_HEM_EXCLUDED.indexOf(w.rangeKey)===-1) meta.push('Sewn hem +20%');
      y+=14; doc.setFontSize(9); doc.setTextColor(138,138,133);
      if(meta.length){doc.text(meta.join(' \xb7 '),M+140,y);y+=13;}else{y+=4;}
      doc.setFontSize(10.5); doc.setTextColor(29,29,27);
      doc.setDrawColor(232,226,218); doc.line(M,y,PW-M,y); y+=14;
    });
    if(y>PH-160){doc.addPage();y=M+10;}
    y+=8;
    var gst=subtotal/11,ex=subtotal-gst;
    doc.setFontSize(10.5); doc.setTextColor(74,74,71);
    doc.text('Subtotal (ex. GST)',PW-M-140,y); doc.text(fmt(ex),PW-M,y,{align:'right'}); y+=16;
    doc.text('GST (10%)',PW-M-140,y); doc.text(fmt(gst),PW-M,y,{align:'right'}); y+=16;
    doc.setDrawColor(29,29,27); doc.setLineWidth(1); doc.line(PW-M-200,y,PW-M,y); y+=22;
    doc.setFontSize(17); doc.setFont('helvetica','bold'); doc.setTextColor(63,117,83);
    doc.text('TOTAL',PW-M-140,y); doc.text(fmt(subtotal),PW-M,y,{align:'right'});
    doc.setFont('helvetica','normal');
    var fy=PH-72;
    doc.setDrawColor(221,215,207); doc.setLineWidth(0.6); doc.line(M,fy,PW-M,fy);
    doc.setFontSize(8.5); doc.setTextColor(138,138,133);
    doc.text('Estimate only. Pricing based on your measurements. Final price may vary based on fabric availability, oversize charges and freight.',M,fy+16);
    doc.text('All prices in AUD include GST. Quote valid 30 days. Curtain & Blind Co \xb7 curtainandblindco.com.au',M,fy+29);
    doc.save('CurtainAndBlindCo-Quote-'+qref+'.pdf');
    toast('Quote downloaded');
  }

  function trunc(s,n){s=String(s);return s.length>n?s.slice(0,n-1)+'…':s;}
  function toast(msg){var t=document.getElementById('cbco-toast');t.textContent=msg;t.classList.add('show');clearTimeout(t._t);t._t=setTimeout(function(){t.classList.remove('show');},2200);}

  /* ── INIT ── */
  document.getElementById('cbco-addBtn').addEventListener('click',addWindow);
  document.getElementById('cbco-downloadBtn').addEventListener('click',downloadPDF);
  document.getElementById('cbco-clearBtn').addEventListener('click',function(){
    if(!state.windows.length)return;
    if(confirm('Remove all windows from your quote?')){state.windows=[];render();toast('All windows cleared');}
  });

  /* ── LAZY PRICE GRID ──
     One range's grid, straight from custom.pricing via that product's
     ?view=pricing template. Cached for the life of the page. */
  function ensurePricing(rangeKey) {
    var r = RANGES && RANGES[rangeKey];
    if (!r || r.pricing || pricingState[rangeKey] === 'loading') return;
    pricingState[rangeKey] = 'loading';
    // NB: no Accept:application/json header. Shopify answers that with its own
    // product JSON API and ignores ?view=, so the theme template never renders.
    fetch(pricingUrl(r.handle))
      .then(function(res){ if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function(data){
        if (!data || !data.pricing) throw new Error('no pricing');
        r.pricing = data.pricing;
        if (data.limits) {
          r.minW = data.limits.minWidth; r.maxW = data.limits.maxWidth;
          r.minH = data.limits.minDrop;  r.maxH = data.limits.maxDrop;
        }
        pricingState[rangeKey] = 'ready';
        render();
      })
      .catch(function(){
        pricingState[rangeKey] = 'error';
        toast('Could not load pricing for ' + (r.label || 'that range') + '. Please try again.');
      });
  }

  /* ── RANGE MANIFEST ──
     Rendered inline by sections/cbco-qg-scripts.liquid from the [RETOOL]
     metafields: labels, categories and dimension limits only. */
  function bootFromManifest() {
    var el = document.getElementById('cbco-qg-manifest');
    if (!el) return false;
    try { RANGES = JSON.parse(el.textContent); } catch (err) { return false; }
    return !!(RANGES && Object.keys(RANGES).length);
  }

  function startBuilder() {
    state.windows.push(makeBlank());
    document.getElementById('cbco-addBtn').style.display='';
    render();
  }

  /* ── SAFETY NET ──
     The manifest is rendered by sections/cbco-qg-scripts.liquid. If that section
     is ever served without it (for example a deploy reverting the section before
     this change has landed in the repo), fall back to the previous static
     snapshot so the tool still works instead of showing a dead page. Those
     prices are stale, hence the console warning. Remove once the deploy
     pipeline is confirmed to carry the section. */
  var LEGACY_PRICING_URL = 'https://cdn.shopify.com/s/files/1/0756/5577/4508/files/quote-generator-pricing_0a5c9bcd-007b-4140-81c8-44dd9ebaa3d5.json?v=1777431257';

  if (bootFromManifest()) {
    startBuilder();
  } else {
    console.warn('[CBC] Quote generator manifest missing; falling back to the static snapshot. Prices may be out of date.');
    fetch(LEGACY_PRICING_URL)
      .then(function(r){ return r.json(); })
      .then(function(data){ RANGES = data; startBuilder(); })
      .catch(function(){
        document.getElementById('cbco-windowList').innerHTML =
          '<div class="qg-loading" style="color:#b85c3a">Unable to load product catalogue. Please refresh the page.</div>';
      });
  }
});
